import { Link } from "react-router-dom";
import {
  companyDescription,
  navItems,
  officialEmail,
  officialPhone,
  products,
  services,
  socialLinks,
  tagline,
} from "../data/site";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-ink">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_0%,rgba(30,109,255,0.18),transparent_30%),radial-gradient(circle_at_80%_20%,rgba(74,24,255,0.14),transparent_28%)]" />
      <div className="container relative z-10 py-14">
        <div className="grid gap-10 lg:grid-cols-[1.3fr_0.8fr_0.9fr_0.8fr]">
          <div>
            <Logo />
            <p className="mt-5 max-w-md text-sm leading-7 text-white/60">
              {tagline} {companyDescription}
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {socialLinks.map((link) => (
                <a
                  key={link}
                  href="#"
                  className="rounded-full border border-white/10 px-4 py-2 text-xs font-semibold text-white/60 transition hover:border-electric/50 hover:text-white"
                >
                  {link}
                </a>
              ))}
            </div>
          </div>
          <FooterColumn title="Quick links">
            {navItems.map((item) => (
              <Link key={item.href} to={item.href} className="footer-link">
                {item.label}
              </Link>
            ))}
          </FooterColumn>
          <FooterColumn title="Services">
            {services.slice(0, 7).map((service) => (
              <Link key={service.title} to="/services" className="footer-link">
                {service.title}
              </Link>
            ))}
          </FooterColumn>
          <FooterColumn title="Products">
            {products.slice(0, 7).map((product) => (
              <Link key={product.name} to="/products" className="footer-link">
                {product.name}
              </Link>
            ))}
          </FooterColumn>
        </div>
        <div className="mt-12 flex flex-col gap-4 border-t border-white/10 pt-6 text-sm text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © 2026 Lazerwebs. A subsidiary of Freakyplus Technologies Limited.
            All rights reserved.
          </p>
          <p>
            {officialEmail} · {officialPhone} · Nigeria · Global delivery
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <h2 className="font-display text-sm font-semibold uppercase tracking-[0.22em] text-white/90">
        {title}
      </h2>
      <div className="mt-5 grid gap-3">{children}</div>
    </div>
  );
}
